<div class="spørsmålstittel">
  @if (resultat().spoersmaal.type == spoersmaalstyper.grupperingstittel) {
    <h2 class="grupperingstittel">{{ resultat().spoersmaal.tittel }}</h2>
  } @else {
    <div class="tittel">
      {{ resultat().spoersmaal.tittel }}
      @if (oppsett().visualiseringstype == spoersmaalstyper.fritekst && resultat().resultater.length > 1) {
        <div class="subtittel">{{ 'viser kun svar fra "{tittel}"'|translate:{tittel: resultatPrimaerUndersoekelse().undersoekelseTittel} }}</div>
      }
    </div>
  }
  <ng-content/>
</div>

@if (oppsett()?.visResultat != false) {
  <div class="svar">
    @switch (oppsett().visualiseringstype) {
      @case (spoersmaalstyper.fritekst) {
        <!-- for fritekst spørsmål viser vi kun resultater fra den primære undersøkelsen -->
        @for (svar of resultatPrimaerUndersoekelse().resultat!.fritekst; track $index) {
          <div class="svar-fritekst">
            <html-formatert [innhold]="svar"/>
          </div>
        } @empty {
          <div class="ingen-data">{{ 'Ingen besvarelser'|translate }}</div>
        }
      }
      @case (spoersmaalstyper.boolsk) {
        <div>{{ 'Antall ja:' | translate }} {{ boolskAntallJa() }}</div>
        <div>{{ 'Antall nei:' | translate }} {{ boolskAntallNei() }}</div>
      }
      @case (spoersmaalstyper.rangering) {
        <rangering-resultater-soeylediagram [resultater]="rangeringSomRangeringAggregatOgTittel()" [oppsett]="diagramoppsett()!"/>
      }
      @case (spoersmaalstyper.velgEnAvFlere) {
        <rangering-resultater-soeylediagram [resultater]="velgEnAvFlereSomRangeringAggregatOgTittel()" [oppsett]="diagramoppsett()!"/>
      }
      @case (spoersmaalstyper.velgNoenAvFlere) {
        <rangering-resultater-soeylediagram [resultater]="velgNoenAvFlereSomRangeringAggregatOgTittel()" [oppsett]="diagramoppsett()!"/>
      }
    }
  </div>
}
